// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xk-1";
export var printerIcon = "_xk-0";